<template>
<div class="d-flex">
  <input-container
    :label="label"
    :assistive="assistive"
    :no-assistive="noAssistive"
    :class="{ focused, disabled, invalid }">
    <template #container>
      <slot name="icon-left"></slot>
      <InputComponent
        ref="input"
        :placeholder="placeholder"
        :name="name"
        v-model="input"
        @focus="focus"
        @blur="blur"
        :disabled="disabled"
        :delay="delay"
      />
      <button type="button" class="btn fab fab-sm m-r-16 inline-flex items-center justify-center" v-if="showCleanButton" @click="clear">
        <UIcon name="i-pkg-action-close" class="size-4 text-primary-500" />
      </button>
      <slot name="icon-right"></slot>
    </template>
  </input-container>

    <a target="_blank" :href="input" class="m-l-8 m-t-28 fab fab-lg fab-secondary inline-flex items-center justify-center" :class="{ 'fab-disabled': !count }">
        <UIcon name="i-pkg-navigation-openinnewwindow" class="size-5" />
    </a>
</div>
</template>

<script>
import get from 'lodash/get';

import InputContainer from './input-container.vue';
import InputComponent from './input-component.vue';

export default {
  components: {
    InputContainer,
    InputComponent,
  },
  data() {
    return {
      focused: false,
      input: this.value || '',
    };
  },
  props: {
    noAssistive: {
      type: Boolean,
      default: false,
    },
    enhancerLabel: {
      type: [Boolean, String],
      default: false,
    },
    search: {
      type: Boolean,
      default: false,
    },
    clean: {
      type: Boolean,
      default: false,
    },
    value: {},
    label: {
      type: [String, Boolean],
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    assistive: {
      type: [String, Boolean],
      default: false,
    },
    error: {
      type: [Boolean, String, Array],
      default: false,
    },
    classes: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    reduce: {
      type: Function,
      default: (v) => v,
    },
    delay: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    showCleanButton() {
      return !this.disabled && this.clean && this.value.length;
    },
    invalid() {
      return this.error.length;
    },
    count: {
      get() {
        const input = get(this, 'input', null);

        return input ? input.length : 0;
      },
      set() {

      },
    },
  },
  watch: {
    input(input) {
      this.$emit('input', this.reduce(input));
    },
    value(value) {
      this.input = this.reduce(value);
    },
  },
  methods: {
    focus(focus) {
      this.focused = focus;
    },
    blur(blur) {
      this.focused = blur;
    },
    clear() {
      this.$refs.input.clear();
    },
  },
};
</script>
